import angular from 'angular';
import uiRouter from 'angular-ui-router';
import enquiryEditComponent from './enquiryEdit.component';
import EnquiryBasicDetails from './enquiryBasicDetails/enquiryBasicDetails';
import EnquiryVehicles from './enquiryVehicles/enquiryVehicles';
import EnquiryTestDrives from './enquiryTestDrives/enquiryTestDrives';
import EnquiryTradeIns from './enquiryTradeIns/enquiryTradeIns';
import EnquiryPricing from './enquiryPricing/enquiryPricing';
import EnquiryConclude from './enquiryConclude/enquiryConclude';
import SimpleDpa from './simpleDpa/simpleDpa';
import AllDpa from './allDpa/allDpa';
import sticky from 'ngsticky';
import EnquiryTimeline from './enquiryTimeline/enquiryTimeline';
import EnquiryQuotes from './enquiryQuotes/enquiryQuotes';
import CustomForms from './customForms/customForms';

let enquiryEditModule = angular.module('enquiryEdit', [
  uiRouter,
  EnquiryBasicDetails,
  EnquiryVehicles,
  EnquiryTestDrives,
  EnquiryTradeIns,
  EnquiryPricing,
  EnquiryConclude,
  SimpleDpa,
  AllDpa,
  'sticky',
  EnquiryTimeline,
  EnquiryQuotes,
  CustomForms
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('enquiryAdd', {
      url: '/enquiry/add',
      component: 'enquiryEdit',
      params: {
        contactId: null,
        contactName: null,
        enquiry: null,
        activeTab: null,
        isDpaSet: null,
        isAllDpaSet: null
      }
    });

    $stateProvider
      .state('enquiryEdit', {
        url: '/enquiry/edit/:enquiryId',
        component: 'enquiryEdit',
        params: {
          enquiry: null,
          activeTab: null,
          origin: null
        }
      });

    $stateProvider
      .state('enquiryEditCode', {
        url: '/enquiry/edit/:enquiryId',
        component: 'enquiryEdit',
        params: {
          enquiry: null,
          activeTab: 'conclusion',
          origin: null,
          code: null,
          action: null,
        }
      });      
})

.component('enquiryEdit', enquiryEditComponent)

.name;

export default enquiryEditModule;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiryEdit/enquiryEdit.js